import { ParametroPaginacionGenerico } from "src/app/util/ParametroPaginacionGenerico";

export class FiltroCoPedido {

    numerodoc: string;
    fechadoc: Date;
    fechavenc: Date;
    estado: string;
    clientenum: number;
    nombreCliente: string;
    almacen: string;
    usuarioActualCompania: string;
    nombreVendedor: string; 
    moneda:string;   
    constructor() {
        this.paginacion = new ParametroPaginacionGenerico();
    }
    paginacion: ParametroPaginacionGenerico;
}
